import { Injectable, signal } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class CodeEditorService {
	isLoaded = signal<boolean>(false)
	private isLoading = false

	public load() {
		if (this.isLoading || this.isLoaded()) return
		this.isLoading = true
		// load the assets

		const baseUrl = './assets' + '/monaco-editor/min/vs'

		if (typeof (<any>window).monaco === 'object') {
			this.isLoaded.set(true)
			return
		}

		const onGotAmdLoader: any = () => {
			// load Monaco
			;(<any>window).require.config({ paths: { vs: `${baseUrl}` } })
			;(<any>window).require([`vs/editor/editor.main`], () => {
				this.isLoaded.set(true)
			})
		}

		// load AMD loader, if necessary
		if (!(<any>window).require) {
			const loaderScript: HTMLScriptElement = document.createElement('script')
			loaderScript.type = 'text/javascript'
			loaderScript.src = `${baseUrl}/loader.js`
			loaderScript.addEventListener('load', onGotAmdLoader)
			document.body.appendChild(loaderScript)
		} else {
			onGotAmdLoader()
		}
	}
}
